import { render, staticRenderFns } from "./project.vue?vue&type=template&id=6768a009&scoped=true&"
import script from "./project.vue?vue&type=script&lang=js&"
export * from "./project.vue?vue&type=script&lang=js&"
import style0 from "./project.vue?vue&type=style&index=0&id=6768a009&prod&scoped=true&lang=less&"
import style1 from "./project.vue?vue&type=style&index=1&id=6768a009&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6768a009",
  null
  
)

export default component.exports